import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy, OnChanges } from '@angular/core';

import { Sale } from '../../models/sale/sale.model';
import { Utilities } from '../../utilities/utilities';
import { Map, List } from 'immutable';
import { Platform } from "@ionic/angular";

import { Router } from '@angular/router';

import { SaleService } from '../../services/'
import { NavigationStateService } from '../../services/navigation-state.service';

export interface SaleSelectEvent {
  sale: Sale
}

@Component({
  selector: 'smr-sale-list',
  templateUrl: './sale-list.component.html',
  styleUrls: ['./sale-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SaleListComponent implements OnChanges{

  @Input() sales: List<Sale>;

  @Input() isReadOnly: boolean = false;

  @Output() saleSelect = new EventEmitter<SaleSelectEvent>();

  public salesArray: Array<Sale>;

  public windowWidth: any;

  // public groupedSales: List<{date: string, sales: List<Sale>}>;

  constructor (public platform: Platform, private router: Router, private saleService: SaleService, private navigationStateService: NavigationStateService) {
    this.sales= List([]);
    // this.groupedSales = List([]);
    this.salesArray = []
    this.onSaleSelect = this.onSaleSelect.bind(this);
    this.windowWidth = platform.width();
  }

  onResize(event) {
    this.windowWidth = event.target.innerWidth;
  }

  public ngOnChanges (changes) {
    // this.groupSales();
    this.salesArray = this.sales.toArray();
  }

  public onSaleSelect (sale: Sale) {
    this.saleSelect.emit({
      sale: sale
    });
  }

  public navigate (sale) {
    if(sale.status === 1) {
      this.router.navigate(['./sales/sale-receipt/'+ sale.id])
    }
    else if (sale.status === 2) {

      if(this.isReadOnly) {
        return;
      }

      this.saleService.loadSaleByID(sale.id).subscribe((sale) => {

        this.navigationStateService.setState({
          sale: sale, 
        });
        this.router.navigate(
          ['sales/sale-checkout']
          );
        })
    }
  }

  // public groupSales () {
  //   this.groupedSales = List([]);
  //   let salesMap: Map<string, List<Sale>> = Map.of();
  //   this.sales.forEach((sale: Sale) => {
  //     const date: string = Utilities.formatDate(sale.datetime, 'dddd, MMMM DD Y');

  //     if (salesMap.has(date)) {
  //       salesMap = salesMap.update(date, (sales: List<Sale>) => {
  //         return sales.push(sale);
  //       });
  //     } else {
  //       salesMap = salesMap.set(date, List([sale]));
  //     }

  //   });

  //   salesMap.entrySeq().forEach((entry) => {
  //     const date: string = entry[0];
  //     const sales: List<Sale> = entry[1];
  //     this.groupedSales = this.groupedSales.push({date: date, sales: sales});
  //   });

  // }

}
